import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Moment from 'react-moment';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import {
  CardActions,
  CardContent,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import { Cancel, Edit, Save } from '@material-ui/icons';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },

  // Purple contest description line (leave unchanged)
  currentContest: {
    textAlign: 'center',
    fontSize: 18,
    color: theme.palette.primary.main,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    lineHeight: 1.5,
    display: 'block',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      lineHeight: 1.45,
    },
  },

  // FIX: make the right card's title behave like the left card's "Current Contest" heading
  // - no color changes here (inherits whatever your theme/card already uses)
  // - avoid giant clamp sizing so it won't dominate the card
  contestHeading: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontSize: '1.5rem',
    lineHeight: 1.2,
    fontWeight: 600,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.35rem',
      marginBottom: theme.spacing(1.5),
    },
  },

  contestText: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      minHeight: '2.75rem',
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '1rem',
      lineHeight: 1.4,
      padding: '0.9rem 0.875rem',
    },
    '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
      borderColor: 'white',
    },
    [theme.breakpoints.down('sm')]: {
      '& .MuiOutlinedInput-input': {
        fontSize: '1rem',
        padding: '0.95rem 0.8rem',
      },
    },
  },
  contestDateTime: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      minHeight: '2.75rem',
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '1rem',
    },
    '& .MuiSelect-select': {
      textAlign: 'left',
    },
    '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
      borderColor: 'white',
    },
  },
  timeOptions: {
    '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
      borderColor: 'white',
    },
  },
  contestNumber: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      minHeight: '2.75rem',
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '1rem',
    },
    '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
      borderColor: 'white',
    },
  },
  input: {
    color: 'white',
  },
  cssOutlinedInput: {
    '&$cssFocused $notchedOutline': {
      borderColor: 'white',
    },
  },
  cssFocused: {},
  notchedOutline: { borderColor: 'white' },
  editFields: {
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0.5),
    },
  },
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '8px 0 0',
    alignItems: 'center',
  },
  secondaryAction: {
    marginLeft: 'auto',
  },
  actionButton: {
    minHeight: '2.75rem',
    padding: '0.625rem 1rem',
    fontSize: '0.98rem',
    '& + &': {
      marginLeft: theme.spacing(1),
    },
  },
});

class UpdateContest extends Component {
  state = {
    contestEdits: {
      newContestName: this.props.currentContest.contest_name,
      newStartDate: this.props.currentContest.start_date,
      newStartTime: this.props.currentContest.start_time,
      newNumberOfHours: this.props.currentContest.number_of_hours,
      newNumberOfQuestions: this.props.currentContest.number_of_questions,
      newContestId: this.props.currentContest.id,
    },
    editContest: false,
  };

  componentDidMount() {
    this.getContestDetails();
  }

  getContestDetails() {
    this.props.dispatch({
      type: 'FETCH_CURRENT_CONTEST',
      payload: this.props.user,
    });
  }

  toggleContestEdit = () => {
    this.setState({
      editContest: !this.state.editContest,
    });
  };

  handleContestSave = () => {
    this.props.dispatch({
      type: 'UPDATE_CURRENT_CONTEST_DETAILS',
      payload: this.state.contestEdits,
    });
    this.setState({
      editContest: !this.state.editContest,
    });
  };

  handleChangeFor = propertyName => event => {
    this.setState({
      contestEdits: {
        ...this.state.contestEdits,
        [propertyName]: event.target.value,
      },
    });
  };

  handleEditContest = id => {
    this.setState({
      editContest: !this.state.editContest,
      contestEdits: {
        ...this.state.contestEdits,
        newContestId: id,
        newContestName: this.props.currentContest.contest_name,
        newStartDate: this.props.currentContest.start_date,
        newStartTime: this.props.currentContest.start_time,
        newNumberOfHours: this.props.currentContest.number_of_hours,
        newNumberOfQuestions: this.props.currentContest.number_of_questions,
      },
    });
  };

  render() {
    const { classes } = this.props;

    let converter = require('number-to-words');

    let contestTime = this.props.currentContest.start_time;
    let stringContestTime = '' + contestTime;

    if (this.props.currentContest.start_time == 0) {
      contestTime = '12 am';
    } else if (this.props.currentContest.start_time < 12) {
      contestTime = stringContestTime + ' am';
    } else if (this.props.currentContest.start_time == 12) {
      contestTime = '12 pm';
    } else if (this.props.currentContest.start_time < 24) {
      contestTime = stringContestTime - 12 + ' pm';
    }

    let hourSelection = [];

    for (let i = 0; i < 24; i++) {
      let hourFormat = {
        displayValue: 0,
        sqlValue: 0,
      };
      hourFormat.sqlValue = i;
      if (i == 0) {
        hourFormat.displayValue = '12 am';
        hourSelection.push(hourFormat);
      } else if (i < 12) {
        hourFormat.displayValue = i + ' am';
        hourSelection.push(hourFormat);
      } else if (i == 12) {
        hourFormat.displayValue = '12 pm';
        hourSelection.push(hourFormat);
      } else if (i <= 23) {
        let j = i;
        hourFormat.displayValue = j - 12 + ' pm';
        hourSelection.push(hourFormat);
      }
    }

    let hours = this.props.currentContest.number_of_hours;
    let hoursAsWords = converter.toWords(hours ? hours : 0);

    let numberOfQuestions = this.props.currentContest.number_of_questions;
    let numberOfQuestionsAsWords = converter.toWords(numberOfQuestions ? numberOfQuestions : 0);

    let name = hoursAsWords;
    let nameCapitalized = name.charAt(0).toUpperCase() + name.slice(1);

    return (
      <div>
        <CardContent>
          <h2 className={classes.contestHeading}>{this.props.currentContest.contest_name}</h2>

          <span className={classes.currentContest}>
            {nameCapitalized} hours long, {numberOfQuestionsAsWords} questions per hour.
            <br />
            Beginning <Moment format="MM/DD/YYYY" date={this.props.currentContest.start_date} /> at {contestTime}.
          </span>

          <Typography color="secondary" component="div">
            {this.state.editContest && (
              <Grid container spacing={2} className={classes.editFields}>
                <Grid item xs={12}>
                  <TextField
                    id="edit-contest-name"
                    label="current contest"
                    className={classes.contestText}
                    value={this.state.contestEdits.newContestName}
                    onChange={this.handleChangeFor('newContestName')}
                    margin="normal"
                    variant="outlined"
                    InputProps={{
                      className: classes.input,
                      classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline,
                      },
                    }}
                    InputLabelProps={{
                      className: classes.input,
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    type="date"
                    id="edit-contest-date"
                    label="contest start date"
                    className={classes.contestDateTime}
                    value={this.state.contestEdits.newStartDate}
                    onChange={this.handleChangeFor('newStartDate')}
                    margin="normal"
                    variant="outlined"
                    InputProps={{
                      className: classes.input,
                      classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline,
                      },
                    }}
                    InputLabelProps={{
                      className: classes.input,
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id="edit-contest-time"
                    select
                    label="contest start time"
                    className={classes.contestDateTime}
                    value={this.state.contestEdits.newStartTime}
                    onChange={this.handleChangeFor('newStartTime')}
                    margin="normal"
                    variant="outlined"
                    InputProps={{
                      className: classes.input,
                      classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline,
                      },
                    }}
                    InputLabelProps={{
                      className: classes.input,
                      shrink: true,
                    }}
                  >
                    {hourSelection.map(hour => (
                      <MenuItem key={hour.sqlValue} value={hour.sqlValue} className={classes.timeOptions}>
                        {hour.displayValue}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id="edit-contest-hours"
                    type="number"
                    label="number of hours"
                    className={classes.contestNumber}
                    value={this.state.contestEdits.newNumberOfHours}
                    onChange={this.handleChangeFor('newNumberOfHours')}
                    margin="normal"
                    variant="outlined"
                    InputProps={{
                      className: classes.input,
                      classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline,
                      },
                    }}
                    InputLabelProps={{
                      className: classes.input,
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id="edit-contest-questions"
                    type="number"
                    label="questions per hour"
                    className={classes.contestNumber}
                    value={this.state.contestEdits.newNumberOfQuestions}
                    onChange={this.handleChangeFor('newNumberOfQuestions')}
                    margin="normal"
                    variant="outlined"
                    InputProps={{
                      className: classes.input,
                      classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline,
                      },
                    }}
                    InputLabelProps={{
                      className: classes.input,
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
            )}
          </Typography>
        </CardContent>

        <CardActions className={classes.actions}>
          {!this.state.editContest && this.props.user.clearance_id > 1 && (
            <Button
              color="secondary"
              variant="outlined"
              className={classes.actionButton}
              onClick={() => this.handleEditContest(this.props.currentContest.id)}
            >
              <Edit style={{ marginRight: 3 }} />
              Edit
            </Button>
          )}

          {this.state.editContest && this.props.user.clearance_id > 1 && (
            <Button
              color="secondary"
              variant="outlined"
              className={classes.actionButton}
              onClick={this.toggleContestEdit}
            >
              <Cancel style={{ marginRight: 3 }} />
              Cancel
            </Button>
          )}

          {this.state.editContest && this.props.user.clearance_id > 1 && (
            <Button
              onClick={this.handleContestSave}
              className={`${classes.secondaryAction} ${classes.actionButton}`}
              style={{ color: this.props.user.color }}
            >
              <Save style={{ marginRight: 3 }} />
              Save
            </Button>
          )}
        </CardActions>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  currentContest: state.currentContest,
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(UpdateContest)));
